import { FC, ReactNode } from 'react';
import styled from 'styled-components';

export const Div = styled.div`
  & > * {
    margin-right: 2.5em;
    margin-bottom: 3em;
  }

  @media only screen and (max-width: 640px) {
    & > * {
      margin-right: 0;
      margin-bottom: 3em;
    }
  }
`;

const Container: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <Div className="flex items-top justify-between lg:justify-start container flex-col md:flex-row md:flex-wrap px-2 md:px-12 mx-auto py-6">
      {children}
    </Div>
  );
};

export default Container;
